const CREATE_METASITE_URL = '/_serverless/domains-storefront-serverless/api/create-metasite';
export const createMetasite = async _ref => {
  let httpClient = _ref.httpClient;
  const _await$httpClient$pos = await httpClient.post(CREATE_METASITE_URL),
    data = _await$httpClient$pos.data;
  return data;
};
//# sourceMappingURL=createMetasite.js.map